import {Action, handleActions} from "redux-actions";
import {NotificationState} from "./NotificationState";
import {
	NEW_NOTIFICATION,
	NOTIFICATION_STATUS_UPDATED,
	NOTIFICATIONS_FETCHED,
	NOTIFICATIONS_IS_UNREAD_FETCHED,
	NOTIFICATIONS_MARKED_AS_READ
} from "../../action/notification/actionType";
import NotificationBase from "../../../model/notification/NotificationBase";
import _ = require("underscore");

const initState: NotificationState = {
	notifications: [],
	isNotificationUnread: false
};

const reducer = handleActions({
	[NOTIFICATIONS_FETCHED]: (state: NotificationState, action: Action<any>): NotificationState => {
		const notifications = _.uniq([].concat(action.payload.notifications).concat(state.notifications), n => n.id);

		const notificationsObj: { [key: string]: NotificationBase } = (action.payload.notifications as NotificationBase[])
			.reduce((obj: { [key: string]: NotificationBase }, n: NotificationBase) => {
				obj[n.id] = n;
				return obj
			}, {});
		const newNotifications = notifications.map(n => notificationsObj[n.id] ? notificationsObj[n.id] : n);
		return {...state, notifications: newNotifications}
	},
	[NEW_NOTIFICATION]: (state: NotificationState, action: Action<NEW_NOTIFICATION>): NotificationState => {
		return {...state, notifications: state.notifications.concat(action.payload.notification)};
	},
	[NOTIFICATION_STATUS_UPDATED]: (state: NotificationState, action: Action<NOTIFICATION_STATUS_UPDATED>): NotificationState => {
		let notifications: NotificationBase[] = state.notifications;
		action.payload.data.forEach(ns => {
				notifications =
					notifications.map((n: NotificationBase) => {return n.id == ns.notificationId ? n.setReadStatus(ns.read) : n });
			}
		);

		return {...state, notifications: notifications}
	},
	[NOTIFICATIONS_MARKED_AS_READ]: (state: NotificationState): NotificationState => {
		return {
			...state,
			notifications: state.notifications.map(n => !n.read ? n.setReadStatus(true) : n),
			isNotificationUnread: false
		}
	},
	[NOTIFICATIONS_IS_UNREAD_FETCHED]: (state: NotificationState,
		action: Action<NOTIFICATIONS_IS_UNREAD_FETCHED>): NotificationState => {
		return {...state, isNotificationUnread: action.payload.isUnread}
	}
}, initState);

export default reducer;